import React from 'react'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import { useField } from 'formik'
import { useIntl } from 'react-intl'
import { isNil } from 'ramda'
import Radios from 'app/componentV4/Radios'
import useFeatureFlag from 'app/configs/useFeatureFlag'

function StyledRadio(props) {
  return (
    <div className="flex items-center">
      <Radio {...props} className="p-0 h-auto w-auto px-2" />
      {props.iconlabel}
    </div>
  )
}

const MessageOptionFormik = (props) => {
  const { formatMessage } = useIntl()
  const [field, meta, helpers] = useField(props.name)
  const value = field.value
  const setValue = helpers.setValue
  const isError = !isNil(meta.error) && meta.touched
  const { mes_3832_new_design_compose_message } = useFeatureFlag()

  const handleChange = (event) => {
    setValue(event.target.value)
    if (props.onChange) {
      props.onChange(event.target.value)
    }
  }

  return (
    <FormControl component="fieldset">
      <RadioGroup
        {...field}
        name={props.name}
        value={value}
        onChange={handleChange}
        className="p-5 space-y-5 border-grey-400"
      >
        <FormControlLabel
          value="TYPE_SEND_NOW"
          disabled={props.isSendNowDisabled || false}
          control={
            mes_3832_new_design_compose_message ? <Radios /> : <StyledRadio />
          }
          label={formatMessage({
            id: 'createNotification.option.immediately.label',
          })}
        />
        <FormControlLabel
          value="TYPE_SEND_SCHEDULE"
          disabled={props.isScheduleDisabled}
          control={
            mes_3832_new_design_compose_message ? <Radios /> : <StyledRadio />
          }
          label={formatMessage({
            id: 'createNotification.dialog.label.schedule',
          })}
        />
      </RadioGroup>
      {isError && <div className="text-red-500 px-5 mb-5">{meta.error}</div>}
    </FormControl>
  )
}

export default React.memo(MessageOptionFormik)
